import React, { useEffect, useState, useRef, useContext, useCallback, createRef } from "react";
import Calendar, { returnType } from "bodycodi/cmap/app/components/cmap2010/calendar/calendar";
import { DispatchContext } from "bodycodi/cmap/app/components/cmap2010/home";
import { DispatchContext as CommonDispatchContext } from "bodycodi/cmap/app/components/common/context";
import { callApi, addZero, isEmpty, scrollTo } from "bodycodi/cmap/app/js/common";
import { StateContext } from "bodycodi/cmap/app/components/cmap2010/home";

import ScheduleList from "bodycodi/cmap/app/components/cmap2010/scheduleList";
import icon_calendar from "bodycodi/cmap/app/svg/icon_calendar.svg";
import icon_add_schedule from "bodycodi/cmap/app/svg/icon_add_schedule.svg";

import { useSelector } from "react-redux";
import { RootState } from "bodycodi/cmap/app/redux/store";
import { Holiday } from "bodycodi/cmap/app/type";
import AdBanner from "./AdBanner";

const Schedule = () => {
  const { seqPartner, seqPartnerBranch, seqPartnerCoach } = useSelector(
    (state: RootState) => state.partner
  );

  const date = new Date();
  const [scheduleDate, setScheduleDate] = useState({
    year: date.getFullYear(),
    month: date.getMonth(),
  });
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [holidays, setHolidays] = useState<number[]>([]);
  const [scheduleList, setScheduleList] = useState({});
  const [scheduletStateList, setScheduletStateList] = useState({});
  const scrollArea = useRef<HTMLDivElement>(null);
  const { dispatch } = useContext(DispatchContext);
  const { dispatch: commonDispatch } = useContext(CommonDispatchContext);
  const calendar = createRef<HTMLDivElement>();
  const scrollToCalendar = useRef<HTMLDivElement>(null);
  const { state } = useContext(StateContext);
  const [selectedDate, setSelectedDate] = useState(date.getDate());

  useEffect(() => {
    if (seqPartner === 0) {
      return;
    }
    setIsLoading(true);
    const parm: any = { month: scheduleDate.year + "" + addZero(scheduleDate.month + 1) };
    parm.seqPartner = seqPartner;
    parm.seqPartnerBranch = seqPartnerBranch;
    parm.seqPartnerCoach = seqPartnerCoach;
    Promise.all([
      callApi(
        "/schedule/reservation/view-holiday",
        {
          searchDate: `${scheduleDate.year}-${addZero(scheduleDate.month + 1)}-01`,
          seqPartnerCoach,
          seqPartner,
          seqPartnerBranch,
          seqPassInfo: "",
        },
        "POST"
      ),
      callApi("/cmap2010/viewMyScheduleList", parm, "GET"),
    ])
      .then((res) => {
        const holidayObj: { [key: number]: string } = {};
        const holiday = res[0].map((v: Holiday) => {
          const day = parseInt(v.dayOff.substring(8, 10));
          holidayObj[day] = v.holidayType;
          return day;
        });
        setHolidays(holiday);
        const ScheduleList = res[1].ScheduleList;
        const apObject: any = {};
        const classState: any = {};
        for (let i = 0; i < ScheduleList.length; i++) {
          let date = "";
          if (ScheduleList[i].scheduleType.toLowerCase() === "appointment") {
            date = ScheduleList[i].startDate.split(" ")[0];
          } else if (ScheduleList[i].scheduleType.toLowerCase() === "class") {
            date = ScheduleList[i].startDt.split(" ")[0];
          }
          if (isEmpty(apObject[date])) {
            apObject[date] = [ScheduleList[i]];
          } else {
            apObject[date].push(ScheduleList[i]);
          }
        }
        for (const date in apObject) {
          const checkSameTypes: string[] = [];
          classState[date] = [];
          for (let j = 0; j < apObject[date].length; j++) {
            const data = apObject[date][j];
            const classStateType =
              data.scheduleType === "appointment"
                ? data.appointmentClCd === "ET"
                  ? "ET"
                  : "AP"
                : data.scheduleType;
            if (checkSameTypes.includes(classStateType)) {
              continue;
            }
            classState[date].push(classStateType);
            checkSameTypes.push(classStateType);
            if (classStateType.length === 3) {
              break;
            }
          }
        }
        setScheduleList(apObject);
        setScheduletStateList(classState);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [
    seqPartner,
    seqPartnerBranch,
    seqPartnerCoach,
    scheduleDate.month,
    scheduleDate.year,
    state.mySchedule.refresh,
  ]);

  const update = useCallback(() => {
    dispatch({ type: "UPDATE_SCHDULE" });
  }, []);

  const clickDate = ({ year, month, date }: returnType) => {
    setSelectedDate(date);

    // const startDate = year + "-" + addZero(month) + "-" + addZero(date);
    // const target = scrollArea.current?.querySelector("[data-date='" + startDate + "']");
    // const fixElement = scrollArea.current?.querySelectorAll(
    //   ".schedule-date-list"
    // )[0] as HTMLDivElement;
    // if (target) {
    //   const rect = target.getBoundingClientRect();
    //   const scrollAreaRect = scrollArea.current?.getBoundingClientRect()!;
    //   const fixHeight = fixElement.offsetHeight;
    //   scrollTo({
    //     element: scrollArea.current,
    //     to: rect.top - scrollAreaRect.top + scrollArea.current!.scrollTop,
    //     duration: 500,
    //   });
    // }
  };

  const onScroll = () => {
    const { current: scrollTo } = scrollToCalendar;
    if (scrollArea.current) {
      if (scrollArea.current?.scrollTop > 450) {
        scrollTo?.classList.add("on");
      } else {
        scrollTo?.classList.remove("on");
      }
    }
  };

  const scrollTop = () => {
    scrollTo({ element: scrollArea.current, to: 0, duration: 500 });
    //window.location.href='https://accounts.google.com/o/oauth2/auth?access_type=offline&client_id=22850224542-ll0vbdd3nr5ob5ggeovtv0lv0g3roe54.apps.googleusercontent.com&redirect_uri=http://localhost:3040/api/cmap2010/viewGclRedirect&response_type=code&scope=https://www.googleapis.com/auth/calendar';
  };

  const clickAdd = () => {
    commonDispatch({ type: "UPDATE", data: { addScheduleStep: 1 } });
    commonDispatch({
      type: "POP_UP_OPEN",
      id: "CHOOSE_SCHEDULE_TYPE",
      open: { chooseServiceTypePop: true },
    });
  };

  return (
    <>
      <AdBanner />

      <div className="schedule-wrap" ref={scrollArea} onScroll={onScroll}>
        <Calendar
          onClick={clickDate}
          onChangeMonth={setScheduleDate}
          holidays={holidays}
          scheduletStateList={scheduletStateList}
          ref={calendar}
          isAddStep={false}
          hasTodayBtn={true}
        />
        <ScheduleList
          isLoading={isLoading}
          scheduletList={scheduleList}
          update={update}
          selectedDate={selectedDate}
          scheduleDate={scheduleDate}
        />
      </div>
      <div className="add-schedule" onClick={clickAdd}>
        <img src={icon_add_schedule} />
      </div>
      <div className="scroll-to-calendar" ref={scrollToCalendar} onClick={scrollTop}>
        <img src={icon_calendar} />
      </div>
    </>
  );
};

export default Schedule;
